import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

interface PriceDisplayProps {
	price: number;
	isLoading?: boolean;
	className?: string;
	loadingText?: string;
}

/**
 * A reusable component for displaying prices with loading state handling
 */
const PriceDisplay: FC<PriceDisplayProps> = ({
	price,
	isLoading = false,
	className,
	loadingText = 'Loading price...'
}) => {
	return (
		<span className={classNames(className)}>
			{isLoading || price === 0 ? (
				<span className={styles.loading}>{loadingText}</span>
			) : (
				<>${price.toFixed(2)}</>
			)}
		</span>
	);
};

export default PriceDisplay;
